const namespaced = true

const state = {
  settings: {}
}

const mutations = {
  setOverrideSettings (state, data) {
    state.settings = data.settings
  }
}

const getters = {
  getOverrideSettings: (state) => {
    return state
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/overrideSettings.js